/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Toast_Rate_LimitedInputs */



/**
* | output |
* | --- |
* | "We are receiving too many reports right now. Please try again in a few minutes." |
*
* @param {Support_Toast_Rate_LimitedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const support_toast_rate_limited = /** @type {((inputs?: Support_Toast_Rate_LimitedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Toast_Rate_LimitedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gerade gehen sehr viele Meldungen bei uns ein. Bitte versuche es in ein paar Minuten erneut.")
	return /** @type {LocalizedString} */ ("We are receiving too many reports right now. Please try again in a few minutes.")
});